import { findQueryBuilder } from '@/app/utils/findQueryBuilder';
import AuditsExport from '@spraypaint/audits/AuditsExport';

const findQuery = findQueryBuilder(AuditsExport);
export const buildAuditsExportFindQuery = findQuery.buildQuery;
export const buildAuditsExportFindQueryLoader = findQuery.buildLoader;
export const useAuditsExportFindQuery = findQuery.useFindQuery;
